<template>
    <div class="history-root now-warning-root">

        <div class="table-wrap clearfix" v-loading="realtimeWarningListLoading" element-loading-text="加载中" style="margin-bottom:140px">
            <el-table
              :data="gongdanList"
              stripe
              :row-style="tableRowStyle"
              :header-cell-style="headerCellStyle"
              :max-height = 620
              style="width: 100%;">

            <el-table-column
              label="序号"
              width="60"  align="center"
              type="index"
              :index="indexMethod">
            </el-table-column>
              <el-table-column
                prop="createTime"  align="center" width="160" 
                label="创建时间">
              </el-table-column>
              <el-table-column
                width="180"  align="center"
                prop="username"
                label="登陆账户">
              </el-table-column>
              <el-table-column
                prop="workContentOrderKey" align="left" width="172"
                label="服务内容">
                <template slot-scope="scope">
                            <span v-if=" scope.row.workContentOrderKey[0] !=null"><span v-if="scope.row.workContentOrderKey[0].contentId == 1"><i class="iconfont icon-icon--" style="margin-right:5px"></i>专职电气顾问服务</span></span>
                            <span v-if=" scope.row.workContentOrderKey[0] !=null"><span v-if="scope.row.workContentOrderKey[0].contentId == 4"><i class="iconfont icon-icon--" style="margin-right:5px"></i>电气线路整改服务</span></span>
                            <span v-if=" scope.row.workContentOrderKey[0] !=null"><span v-if="scope.row.workContentOrderKey[0].contentId == 5"><i class="iconfont icon-icon--" style="margin-right:5px"></i>日常线路巡检服务</span></span>
                            <span v-if=" scope.row.workContentOrderKey[1] !=null"><span v-if="scope.row.workContentOrderKey[1].contentId == 1"><i class="iconfont icon-icon--" style="margin-right:5px"></i>专职电气顾问服务</span></span>
                            <span v-if=" scope.row.workContentOrderKey[1] !=null"><span v-if="scope.row.workContentOrderKey[1].contentId == 4"><i class="iconfont icon-icon--" style="margin-right:5px"></i>电气线路整改服务</span></span>
                            <span v-if=" scope.row.workContentOrderKey[1] !=null"><span v-if="scope.row.workContentOrderKey[1].contentId == 5"><i class="iconfont icon-icon--" style="margin-right:5px"></i>日常线路巡检服务</span></span>
                            <span v-if=" scope.row.workContentOrderKey[2] !=null"><span v-if="scope.row.workContentOrderKey[2].contentId == 1"><i class="iconfont icon-icon--" style="margin-right:5px"></i>专职电气顾问服务</span></span>
                            <span v-if=" scope.row.workContentOrderKey[2] !=null"><span v-if="scope.row.workContentOrderKey[2].contentId == 4"><i class="iconfont icon-icon--" style="margin-right:5px"></i>电气线路整改服务</span></span>
                            <span v-if=" scope.row.workContentOrderKey[2] !=null"><span v-if="scope.row.workContentOrderKey[2].contentId == 5"><i class="iconfont icon-icon--" style="margin-right:5px"></i>日常线路巡检服务</span></span>
                            <span v-if=" scope.row.workContentOrderKey[3] !=null"><span v-if="scope.row.workContentOrderKey[3].contentId == 1"><i class="iconfont icon-icon--" style="margin-right:5px"></i>专职电气顾问服务</span></span>
                            <span v-if=" scope.row.workContentOrderKey[3] !=null"><span v-if="scope.row.workContentOrderKey[3].contentId == 4"><i class="iconfont icon-icon--" style="margin-right:5px"></i>电气线路整改服务</span></span>
                            <span v-if=" scope.row.workContentOrderKey[3] !=null"><span v-if="scope.row.workContentOrderKey[3].contentId == 5"><i class="iconfont icon-icon--" style="margin-right:5px"></i>日常线路巡检服务</span></span>
                            <span v-if=" scope.row.workContentOrderKey[4] !=null"><span v-if="scope.row.workContentOrderKey[4].contentId == 1"><i class="iconfont icon-icon--" style="margin-right:5px"></i>专职电气顾问服务</span></span>
                            <span v-if=" scope.row.workContentOrderKey[4] !=null"><span v-if="scope.row.workContentOrderKey[4].contentId == 4"><i class="iconfont icon-icon--" style="margin-right:5px"></i>电气线路整改服务</span></span>
                            <span v-if=" scope.row.workContentOrderKey[4] !=null"><span v-if="scope.row.workContentOrderKey[4].contentId == 5"><i class="iconfont icon-icon--" style="margin-right:5px"></i>日常线路巡检服务</span></span>
                            <span v-if=" scope.row.workContentOrderKey[5] !=null"><span v-if="scope.row.workContentOrderKey[5].contentId == 1"><i class="iconfont icon-icon--" style="margin-right:5px"></i>专职电气顾问服务</span></span>
                            <span v-if=" scope.row.workContentOrderKey[5] !=null"><span v-if="scope.row.workContentOrderKey[5].contentId == 4"><i class="iconfont icon-icon--" style="margin-right:5px"></i>电气线路整改服务</span></span>
                            <span v-if=" scope.row.workContentOrderKey[5] !=null"><span v-if="scope.row.workContentOrderKey[5].contentId == 5"><i class="iconfont icon-icon--" style="margin-right:5px"></i>日常线路巡检服务</span></span>
                            <span v-if=" scope.row.workContentOrderKey[3] !=null"><span v-if="scope.row.workContentOrderKey[3].contentId == 2"><i class="iconfont icon-icon--"></i>24小时远程值守服务</span></span>
                            <span v-if=" scope.row.workContentOrderKey[2] !=null"><span v-if="scope.row.workContentOrderKey[2].contentId == 2"><i class="iconfont icon-icon--"></i>24小时远程值守服务</span></span>
                            <span v-if=" scope.row.workContentOrderKey[1] !=null"><span v-if="scope.row.workContentOrderKey[1].contentId == 2"><i class="iconfont icon-icon--"></i>24小时远程值守服务</span></span>
                            <span v-if=" scope.row.workContentOrderKey[0] !=null"><span v-if="scope.row.workContentOrderKey[0].contentId == 2"><i class="iconfont icon-icon--"></i>24小时远程值守服务</span></span>
                            <span v-if=" scope.row.workContentOrderKey[4] !=null"><span v-if="scope.row.workContentOrderKey[4].contentId == 2"><i class="iconfont icon-icon--"></i>24小时远程值守服务</span></span>
                            <span v-if=" scope.row.workContentOrderKey[5] !=null"><span v-if="scope.row.workContentOrderKey[5].contentId == 2"><i class="iconfont icon-icon--"></i>24小时远程值守服务</span></span>
                            <span v-if=" scope.row.workContentOrderKey[5] !=null"><span v-if="scope.row.workContentOrderKey[5].contentId == 3"><i class="iconfont icon-icon--"></i>电气线路隐患排查服务</span></span>
                            <span v-if=" scope.row.workContentOrderKey[4] !=null"><span v-if="scope.row.workContentOrderKey[4].contentId == 3"><i class="iconfont icon-icon--"></i>电气线路隐患排查服务</span></span>
                            <span v-if=" scope.row.workContentOrderKey[3] !=null"><span v-if="scope.row.workContentOrderKey[3].contentId == 3"><i class="iconfont icon-icon--"></i>电气线路隐患排查服务</span></span>
                            <span v-if=" scope.row.workContentOrderKey[2] !=null"><span v-if="scope.row.workContentOrderKey[2].contentId == 3"><i class="iconfont icon-icon--"></i>电气线路隐患排查服务</span></span>
                            <span v-if=" scope.row.workContentOrderKey[1] !=null"><span v-if="scope.row.workContentOrderKey[1].contentId == 3"><i class="iconfont icon-icon--"></i>电气线路隐患排查服务</span></span>
                            <span v-if=" scope.row.workContentOrderKey[0] !=null"><span v-if="scope.row.workContentOrderKey[0].contentId == 3"><i class="iconfont icon-icon--"></i>电气线路隐患排查服务</span></span>
                            <span v-if=" scope.row.workContentOrderKey[4] !=null"><span v-if="scope.row.workContentOrderKey[4].contentId == 6"><i class="iconfont icon-icon--"></i>其他</span></span>
                            <span v-if=" scope.row.workContentOrderKey[3] !=null"><span v-if="scope.row.workContentOrderKey[3].contentId == 6"><i class="iconfont icon-icon--"></i>其他</span></span>
                            <span v-if=" scope.row.workContentOrderKey[2] !=null"><span v-if="scope.row.workContentOrderKey[2].contentId == 6"><i class="iconfont icon-icon--"></i>其他</span></span>
                            <span v-if=" scope.row.workContentOrderKey[1] !=null"><span v-if="scope.row.workContentOrderKey[1].contentId == 6"><i class="iconfont icon-icon--"></i>其他</span></span>
                            <span v-if=" scope.row.workContentOrderKey[0] !=null"><span v-if="scope.row.workContentOrderKey[0].contentId == 6"><i class="iconfont icon-icon--"></i>其他</span></span>
                            <span v-if=" scope.row.workContentOrderKey[5] !=null"><span v-if="scope.row.workContentOrderKey[0].contentId == 6"><i class="iconfont icon-icon--"></i>其他</span></span>
                </template>            
              </el-table-column>
              <el-table-column
                width="160"  align="center"
                prop="contact"
                label="联系人">
              </el-table-column>
              <el-table-column
                width="240"  align="center"
                 prop="contactInformation"
                label="联系方式">
              </el-table-column>
                <el-table-column
                        width="240"  align="center"
                        prop="content"
                        label="留言内容">
                </el-table-column>
                <el-table-column
                        width="240"  align="center"
                        prop="feedback"
                        label="反馈内容">
                </el-table-column>
                <el-table-column
                        width="160"  align="center"
                        prop="feedbackTime"
                        label="反馈时间">
                </el-table-column>

              <el-table-column
                prop="status"  align="center"
                label="反馈状态">
                <template slot-scope="scope">
                            <span v-if="scope.row.status == 1">已反馈</span>
                            <span v-if="scope.row.status == 0">未反馈</span>
                </template>
              </el-table-column>
                <el-table-column
                        width="240"  align="center"
                        prop="processingTime"
                        label="处理时间">
                </el-table-column>
              <el-table-column
                prop="del"  align="center"
                label="处理状态">
                <template slot-scope="scope">
                            <span v-if="scope.row.del == 1">已处理</span>
                            <span v-if="scope.row.del == 0">未处理</span>
                </template>
              </el-table-column>
            <el-table-column label="修改工单" align="center" width="250">
                <template slot-scope="scope">
                    <el-button type="primary"  class="el-button el-button--text el-button--mini" @click="xiugaiBtn(scope.row)" >修改</el-button>
                </template>
            </el-table-column>
            </el-table>
        </div>
          <div>
            <base-pagination
                            v-if="pageData.totalPage > 0"
                            :current_page="pageData.pageNum"
                            :total_page="pageData.total"
                            :per_page="pageData.totalPage"
                            @paginate="fetchPage"/>
          </div>
<!--        修改对话框-->
        <el-dialog  :visible.sync="dialogVisible"  width="100%" margin-top='10vh' style="z-index:10000" class="dialog11">
    <div style="border: 1px solid transparent;">
        <div class="password-reset">
            <h1 class="title" style="font-weight:600">修改工单</h1>
            <div class="password-reset-wrap">
                <div class="gongdan_text">
                 <p style="font-weight:600">尊敬的用户：</p>   
                 <p style="margin-left: 26px;">您好！欢迎您使用工单服务，您安装的智能传感采集终端监测到用电线路中存在用电安全及电气火灾隐患，平台发出预警信息，经过</p><p>预处理后，如果安全隐患“未解除”，您可以提交工单，获得专业咨询指导或现场整改服务。</p>
                 <el-form  ref="formName" :model="form">
                     <p style="font-weight:600">1、您想获得的服务？（多选）</p>
                    <el-form-item  prop='contentIds'>
                    <el-checkbox-group v-model="contentIds" >
                          <el-checkbox v-for="label in checkboxData" :label="label.id" :key="label.id" >{{label.name}}</el-checkbox>
                    </el-checkbox-group>
                    </el-form-item >
                    <p style="font-weight:600">2、您的问题描述及对我们的要求？</p>
                    <el-form-item prop="content">
                        <textarea style="margin-top: 12px;"  v-model="form.content" class="feedcontent" name="feedcontent" id="" cols="30" rows="10" placeholder="请输入您的问题及要求"></textarea>
                    </el-form-item>
                    <p style="font-weight:600">3、您的联系方式？</p>
                    <el-form-item label="负责人：" prop="contact"  class="txt_"  style="margin-top: 24px;" >
                    <el-input v-model="form.contact"></el-input>
                    </el-form-item>
                    <el-form-item label="联系方式：" prop="contactInformation" class="txt_" >
                    <el-input  v-model="form.contactInformation"></el-input>
                    </el-form-item>
                 </el-form>
                </div>

                <div class="form-gorup button-group">
                    <el-button @click="cancel">取消</el-button>
                    <el-button @click="submit" type="primary">提交</el-button>
                </div>
            </div>
        </div>
    </div>

        </el-dialog>
    </div>
</template>

<script>
    import common from '@/common/config'
    export default {
        data(){
          return {
              realtimeWarningListLoading: false,
              dialogVisible: false,   //修改对话框
              gongdanList:[],
              isIndeterminate: true,
              //workContentOrderKey:[],
              contentIds:[],
              pageData: {
              current_page: 1,
              total: 1,
              per_page: 1
            },
                form:{},
                checkboxData:[{
                    id:1,
                    name:'专职电气顾问服务：'+"\n"+
                    '委派专职电气工程师，提供专业咨询、指导、故障处理等专业服务。'
                },
                {
                    id:2,
                    name:'24 小时远程值守服务：提供 7*24 小时远程值守服务，一旦报警立即通知到用户。'
                },
                {
                    id:3,
                    name:'电气线路隐患排查服务：根据平台报警信息，研判报警原因，对存在的电气线路隐患进行分析定位，提供完整的优化方案。'
                },
                {
                    id:4,
                    name:'电气线路整改服务：根据预警数据和用电运行曲线，由专业服务团队进行现场线路整改及优化，从根源上消除隐患，提高用电效能减少用电安全事故。'
                },
                {
                    id:5,
                    name:'日常线路巡检服务：定期检查地面可见线路和墙面配电箱体内的接线、紧固线缆接头、清理线缆接点灰尘，并对用电线路进行过载、温度、漏电等检测。'
                },{
                    id:6,
                    name:'其他：（电气火灾预警、智能空开、烟感、可燃气体等智能传感采集终端设备试用；安全知识培训；电气火灾防控演练等）。'
                }
                ],
          }
        },
        mounted(){
          this.zindex = 1000000;
          this.gongDanList();
        },
        computed: {
        },
        methods: {
      handleCheckedCitiesChange(value) {
        let checkedCount = value.length;
        this.checkAll = checkedCount === this.checkboxData.length;
        this.isIndeterminate = checkedCount > 0 && checkedCount < this.checkboxData.length;
      },
          tableRowStyle({row,rowIndex}){
            return 'text-align:center'
          },
          headerCellStyle({ row, column, rowIndex, columnIndex }){
          if (rowIndex === 0) {
            return 'text-align:center;color:#606266'
            }
          },        
          indexMethod(index){
            // return index+1
             return (this.pageData.pageNum-1) * this.pageData.pageSize + index + 1
          },
          fetchPage(page){
            this.pageData.current_page= page;
            this.gongDanList();
          },
          gongDanList(){
             this.realtimeWarningListLoading = true;
            this.$http.post('api/work/index', {
              pageSize:10,
              page: this.pageData.current_page || 1
            }).then( res => {
              this.realtimeWarningListLoading = false;
              this.pageData = res;
              this.gongdanList = res.data;
            }).catch( error => {
              this.realtimeWarningListLoading = false;
            })
          },  
            xiugaiBtn(row){
              this.dialogVisible = true;
              this.realtimeWarningListLoading = true;
                const detailId = row.orderId || this.orderId;
              this.$http.get('api/work/'+ detailId).then(res => {
                this.realtimeWarningListLoading = false;   //通过ID查询详情
                    this.form = res[0];
                   this.contentIds = res[0].workContentOrderKey.map(item => {return item.contentId})
                  //  console.log(this.contentIds)
                }).catch( error => {})
            }, 
            submit(){
                this.$refs['formName'].validate((valid) => {
                    if (valid) {
                         this.$http.post('api/work/put',{
                           
                      contact: this.form.contact,
                      contactInformation: this.form.contactInformation,
                      content: this.form.content,
                      contentIds: this.contentIds,
                      orderId:this.form.orderId
                         }).then( res => {
                            this.dialogVisible = false;
                            this.realtimeWarningListLoading = false;
                            this.gongDanList()
                        })
                    } else {
                        console.log('验证不通过!!');
                        return false;
                    }
                })
            },
            cancel(){
                this.$store.commit('fadeOutComponent')
            },
        },
    }
</script>
<style lang="scss" scoped>
.el-dialog__headerbtn {
    top: 60px !important;
    right: 60px !important;
}
.v-modal{
  z-index:0!important
}
  .history-root{
    padding:0;
    margin: 25px 40px;
    margin-left: 40px;
  }
  .warning-table tr{
    transition: background .3s linear;
  }
  .warning-table tr:hover{
    background: #cccccc;
    color: #333;
  }
  // .warning-table tr:last-child{
  //   background: #f0f3fb;
  // }
  // .warning-table tr:last-child:hover{
  //   background: #f0f3fb;
  // }
  .dialog-warning-wrap{
    position: fixed;
    background: white;
    margin: auto;
    z-index: 100;
    left:0;
    top:50px;
    right:0;
    bottom:0;
    width: 900px;
    height: 350px;
    .title{
      text-align:center;
      font-size: 12px;
      line-height: 63px;
      font-weight: normal;
      color:#000;
    }
    textarea{
      width: 819px;
      margin: 0 auto;
      display: block;
      height: 200px;
      resize: none;
      padding: 10px;
      border: 1px solid #cccccc;
    }
    .button-group{
      text-align: right;
      padding-right: 31px;
      padding-top:10px;
      button{
        width:90px;
        height: 33px;
        line-height: 33px;
        border-radius: 4px;
        color: #3498db;
      }
      button.confirm{
        background: #3498db;
        color: white;
      }
    }
  }
  .now-warning-root{
    .seacrch-head{
      .filter{
        width: 130px;
        font-size: 12px;
        em{
          display: inline-block;
          width: 87px;
          font-size: 14px;
        }
      }
      .now-warning--condition{
        button.active{
          background: #ffb607;
        }
        .query{
          // background: #cccccc;
        }
      }
    }
  }
  .detail2{
  	display:block;
	width: 68px;
    height: 26px;
    display: inline-block;
    text-align: center;
    line-height: 26px;
    border: 1px solid #41c8f4;
    background:none;
    color: #41c8f4;
    /*border: none;*/
    border-radius: 4px;
  }
.outside_component .closeBtn{
  top: 5px!important;
  right: 25px!important;
}
.el-dialog__wrapper{
  z-index: 999999999999!important;
  top: -41px;
  bottom: -137px;
}
.el-dialog__headerbtn{
  top: 60px!important;
  right: 60px!important;
}
</style>




// WEBPACK FOOTER //
// src/component/base-systemnotice-gongdan.vue